import React from 'react';

import {Box, useMediaQuery, useTheme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';

import {Buttons, Icon, Typography} from 'components';
import clsx from 'clsx';
import {useUser} from 'hooks';
import {date} from 'utils';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        borderRadius: 8,
        padding: theme.spacing(1, 2)
    },
    wrapperRed: {
        background: '#FDF8F6',
        border: `solid 1px ${theme.palette.warningDark}`
    },
    wrapperBlue: {
        background: theme.palette.pale,
        border: `solid 1px ${theme.palette.blue}`
    },
    icon: {
        marginRight: theme.spacing(2),
        marginTop: 3
    },
    iconRed: {
        color: theme.palette.warningDark
    },
    iconBlue: {
        color: theme.palette.blue
    },
    button: {
        minWidth: '180px',
        textAlign: 'left',
        borderRadius: 0
    },
    modal: {
        width: '100%',
        maxWidth: 700
    },
    link: {
        fontSize: 16,
        fontWeight: 700,
        cursor: 'pointer',
        color: theme.palette.blue,
        textDecoration: 'underline'
    },
    amount: {
        whiteSpace: 'nowrap',
        fontWeight: 700
    }
}));

function TapeAlertsPpv() {
    const classes = useStyles();
    const theme = useTheme();
    const companyAllowed = ['35658', '35662']; //NVIDIA LTD + NVIDIA DEV
    const ppvEnDate = new Date('10/04/2025');
    const currentDate = new Date();

    const {user} = useUser();

    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    if (window.location.pathname !== '/epargne') return null;

    const payerCompany =
        user.s2e_profile?.companies?.filter(
            (company) => company.main_company === true && companyAllowed.indexOf(company.id) !== -1
        ) || [];

    if (payerCompany.length <= 0 || currentDate >= ppvEnDate) return null;

    return (
        <Box>
            <Box
                className={clsx(classes.wrapper, classes.wrapperRed)}
                mt={3}
            >
                <Box display="flex">
                    <Icon
                        className={clsx(classes.icon, classes.iconRed)}
                        name="axa-icons-danger"
                        size={24}
                        aria-hidden={true}
                    />
                    <Box
                        display="flex"
                        flexDirection={isMobile ? 'column' : 'row'}
                        justifyContent="space-between"
                        alignItems={isMobile ? 'flex-start' : 'center'}
                        minWidth="100%"
                        pr={4}
                    >
                        <Box>
                            <Typography
                                size={18}
                                color={'warningDark'}
                                semibold
                                localization={'home.optionBulletinChoice'}
                            />
                            <Typography
                                size={16}
                                key={`alert-ppv`}
                                color="dark"
                                gutterBottom={false}
                                localization={'home.ppvEndDate'}
                                values={{
                                    ppvEndDate: date.formatDate(ppvEnDate, user.localization)
                                }}
                                components={{
                                    bold: (
                                        <Typography
                                            component="span"
                                            semibold
                                        />
                                    )
                                }}
                            />
                        </Box>
                        <Buttons.SSO
                            hash="open_sso_s2e"
                            className={classes.button}
                            color="transparent_border_blue"
                            label="Faire votre choix"
                            scope="s2e"
                            endpoint={'/operations/saisieunboppv'}
                            next
                            disabled
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default TapeAlertsPpv;
